import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  overflow-x:hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
export const Title = styled.div`
  width: 100%;
  height: 2.5rem;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  background-color: #1983e2;
  border-radius: 3px 3px 0px 0px;
  cursor: pointer;
  background-color:#1D86FF;

  ${(props) =>
    props.isHidden &&
    css`
      &{
        border-radius: 3px;
      }
    `
  } 

  div{
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  span{
    display: flex;
    min-width:1.3rem;
    min-height: 1.3rem;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    font-weight: 500;
    margin-right: 0.5rem; 
  }

  .white{
    color: #000;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 50%;
  }

  .bigger{
    border-radius: 50px;
    padding: 0 0.5rem;
  }

  .icon{
    font-size: 1.75rem;
    margin-right: 1rem;
  }
`
export const Content = styled.ul`
  display: flex;
  width: 100%;
  max-height: 300px;
  padding:0.75rem;
  flex-direction: column;
  border-radius: 0px 0px 4px 4px;
  background-color:#f6f6f6;
  gap: 0.5rem;
  overflow-y:auto;

  li{
    display:flex;
    width:100%;
    height: 2rem;
    padding: 0.5rem;
    justify-content:left;
    align-items:center;
    color: #6c757d;
    cursor: pointer;
    border-radius: 4px;
    /* border-left: 4px solid transparent; */
    background-color: #ffffff;
    font-size: 1.1rem;
    &:hover{
      /* opacity: .1; */
      color: #1D86FF;
      border-left: 4px solid #1D86FF;
    }
  }

  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }

  ${(props) =>
    props.isHidden &&
    css`
      &{
        height: 0px;
        padding: 0px;
        overflow: hidden;
      }
    `
  }  
  > .selected{
    color: #1D86FF;
    border-left: 4px solid #1D86FF;
    background-color: #ffffff;
    font-weight:bolder;
  }
`;

